// extracted by mini-css-extract-plugin
export var boldText = "_6t-4";
export var checkboxContainer = "_6t-6";
export var closeIcon = "_6t-i";
export var container = "_6t-0";
export var drawer = "_6t-8";
export var drawerContent = "_6t-9";
export var extraSmallText = "_6t-5";
export var fulfillmentGroupTable = "_6t-e";
export var largeText = "_6t-3";
export var loadingSpinnerContainer = "_6t-j";
export var mediumText = "_6t-2";
export var narrow = "_6t-f";
export var notificationLink = "_6t-l";
export var packageCheckIconContainer = "_6t-7";
export var slideoutHeaderActions = "_6t-g";
export var slideoutHeaderActionsShifted = "_6t-h";
export var slideoutHeaderContainer = "_6t-a";
export var slideoutModal = "_6t-c";
export var stickyHeaderWrapper = "_6t-b";
export var table = "_6t-k";
export var tableContainer = "_6t-d";
export var tertiaryText = "_6t-1";